import { Box, Button, TextField } from "@mui/material";

import CustomDropDown from "../../CustomDropdown/CustomDropDown";

import cashIcon from "../../../assets/imgs/exchange/money.png";

import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { SlotMachineBetStatus } from "../../../constants/enum/slot";
import { setAmountPerSpin, setSpinCount } from "../../../reducers/slot.slice";

import useStyles from "./index.styles";

const spins = [
  { value: 1, label: "1 spin" },
  { value: 2, label: "2 spins" },
  { value: 3, label: "3 spins" },
  { value: 4, label: "4 spins" },
  { value: 5, label: "5 spins" },
  { value: 6, label: "6 spins" },
  { value: 7, label: "7 spins" },
  { value: 8, label: "8 spins" },
  { value: 9, label: "9 spins" },
  { value: 10, label: "10 spins" },
];

interface ISlotBetPanelParam {
  finishBet: () => void;
  initializeBet: () => void;
  betDisabled: boolean;
  betStatus: SlotMachineBetStatus;
  isSpinnable: boolean;
}

const SlotBetPanel = ({
  finishBet,
  initializeBet,
  betDisabled,
  betStatus,
  isSpinnable,
}: ISlotBetPanelParam) => {
  const dispatch = useAppDispatch();
  const { classes } = useStyles();
  const { spinCount, amountPerSpin, currentSlotMachineId, slotMachines } =
    useAppSelector((state) => state.slot);

  const handleChangeSpinCount = (e: any) => {
    const spinCount = spins.find(
      (spin) => spin.label === e.target.value
    )?.value;

    dispatch(setSpinCount(spinCount));
  };

  const handleChangeAmount = (e: any) => {
    const amount = parseInt(e.target.value);
    dispatch(setAmountPerSpin(amount));
  };

  return (
    <Box className={classes.panel}>
      <Box className={classes.panelBody}>
        <Box className={classes.input}>
          <TextField
            placeholder="Amount Per Spin"
            value={amountPerSpin}
            onChange={handleChangeAmount}
          />

          <Box
            component="img"
            src={cashIcon}
            sx={{
              width: 20,
              height: 20,
            }}
          ></Box>
        </Box>

        <Box className={classes.spinCount}>
          <CustomDropDown
            items={spins.map((spin) => spin.label)}
            placeholder="Switch Table"
            className={classes.optionSelect}
            handleChange={handleChangeSpinCount}
            value={spins[spinCount - 1].label}
          />
        </Box>

        {betStatus === SlotMachineBetStatus.REQUESTED ? (
          <Button
            className={classes.spinButton}
            onClick={finishBet}
            disabled={!isSpinnable}
          >
            Spin
          </Button>
        ) : (
          <Button
            className={classes.spinButton}
            disabled={
              betDisabled ||
              (slotMachines[currentSlotMachineId] &&
                !slotMachines[currentSlotMachineId].isOpened)
            }
            onClick={initializeBet}
          >
            {slotMachines[currentSlotMachineId]?.isOpened ? (
              "Spin"
            ) : (
              <Box color="red">Closed</Box>
            )}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default SlotBetPanel;
